/*
 * @Date         : 2024-05-09 08:48:12
 * @LastEditors  : LHR
 * @LastEditTime : 2024-08-01 09:33:55
 * @FilePath     : /nova-admin-main/Volumes/D/projet/qijiazhixue_wx_vue/src/permission.js
 */
import router from './router'
// const whiteList = ["/login", "/home/index", '/courseindex', '/usecode/usecode', '/registerDo', '/forgetpass', '/home/classify', '/home/study', '/home/user', '/search', '/study']; // no redirect whitelist

const whiteList = ['/pay', '/qjzx', '/virtue']
const whiteList1 = ['/virtue']
// const wxwhiteList = ["/login", "/home/index", ];
import { Dialog } from 'vant'
import { Toast } from 'vant'
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? to.meta.title : '齐家之学'
  // console.log(to.path)
  // determine whether the user has logged in
  let hasToken = sessionStorage.getItem('userinfo')
  if (hasToken) {
    if (to.path === '/login') {
      next({
        path: '/home/index',
      })
    } else {
      if (to.path == '/usecode/usecode') {
        if (!sessionStorage.getItem('wxuser')) {
          next()
        } else {
          next({
            path: '/home/index',
          })
          // window.location.href = './#/home/index'
        }
      } else {
        next()
      }
    }
  } else {
    if (whiteList1.indexOf(to.path) !== -1) {
      next()
      return
    }
    if (whiteList.indexOf(to.path) == -1) {
      if (to.path == '/usecode/usecode') {
        if (!sessionStorage.getItem('wxuser')) {
          next()
        } else {
          next({
            path: '/home/index',
          })
          // window.location.href = './#/home/index'
        }
      } else {
        next()
      }
    } else {
      // next()
      // console.log(router.currentRoute.value)
      Toast('您还未登录,请登录!')
      if (router.currentRoute.value.query.id) {
        next(
          `/login?redirect=${to.path}?id=${router.currentRoute.value.query.id}`
        )
      } else {
        next(`/login?redirect=${to.path}`)
      }
    }
  }
})
